import { produce } from "immer";
import {
  ADD_TEMPLATE,
  ADD_TEMPLATE_FAILURE,
  ADD_TEMPLATE_SUCCESS,
  //
  DELETE_TEMPLATE,
  DELETE_TEMPLATE_FAILURE,
  DELETE_TEMPLATE_SUCCESS,
  //
  EDIT_TEMPLATE,
  EDIT_TEMPLATE_FAILURE,
  EDIT_TEMPLATE_SUCCESS,
  //
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_FAILURE,
  FETCH_TEMPLATES_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_TEMPLATE_ADD_MODAL,
} from "./constants";

export const initialState = {
  isFetchingTemplates: false,
  team: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentTemplate: {},
  // Delete
  isDeleting: false,
  //
  isSearching: false,
  //
  templateAddModal: {
    open: false,
    isEditing: false,
  },
};

const TemplateReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_TEMPLATES:
        draft.isFetchingTemplates = true;
        draft.team = [];
        break;
      case FETCH_TEMPLATES_SUCCESS:
        draft.isFetchingTemplates = false;
        draft.team = action.payload;
        break;
      case FETCH_TEMPLATES_FAILURE:
        draft.isFetchingTemplates = false;
        draft.team = [];
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentTemplate = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentTemplate = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        draft.currentTemplate = {};
        break;
      // Add
      case ADD_TEMPLATE:
        draft.isSubmitting = true;
        break;
      case ADD_TEMPLATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_TEMPLATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_TEMPLATE:
        draft.isSubmitting = true;
        break;
      case EDIT_TEMPLATE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_TEMPLATE_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_TEMPLATE:
        draft.isDeleting = true;
        break;
      case DELETE_TEMPLATE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_TEMPLATE_FAILURE:
        draft.isDeleting = false;
        break;
      case TOGGLE_TEMPLATE_ADD_MODAL:
        draft.templateAddModal = action.payload;
        break;

      default:
        return state;
    }
  });

export default TemplateReducer;
